module.exports = __webpack_public_path__ + "static/img/whatsapp.28761ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/whatsapp.png
// module id = 5GnK
// module chunks = 4